import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

/** Gate the internal EMR sandbox page behind the `emrSandbox` flag. When off, the route resolves to nothing
 *  and the user is sent to their worklist. The API has its own server-side gate — this is a UI convenience. */
export const emrSandboxGuard: CanActivateFn = () => {
    if (environment.emrSandbox) {
        return true;
    }
    return inject(Router).createUrlTree(['/worklist']);
};
